// Shared TaskType enum - Single source of truth
// Used by frontend, backend services, and GraphQL schema

export enum TaskType {
  ReviewBriefs = 'ReviewBriefs',
  ReviewContents = 'ReviewContents', 
  ReviewProductSubmissions = 'ReviewProductSubmissions',
  SendPayments = 'SendPayments',
  SendBriefs = 'SendBriefs',
  SendWelcomeEmails = 'SendWelcomeEmails',
  SendProductCatalog = 'SendProductCatalog',
  SendContracts = 'SendContracts',
  SendPromoCodes = 'SendPromoCodes',
  SendSalesLinks = 'SendSalesLinks',
  CollaborateCreators = 'CollaborateCreators',
  ReviewApplicants = 'ReviewApplicants',
  ConnectShopify = 'ConnectShopify',
  ConnectInstagram = 'ConnectInstagram',
  ConnectTikTok = 'ConnectTikTok',
  CreateCampaignWorkflow = 'CreateCampaignWorkflow',
  DesignApplicationPage = 'DesignApplicationPage',
  ConfigureBriefTemplate = 'ConfigureBriefTemplate',
  SetupProductCatalog = 'SetupProductCatalog',
  DefineOffers = 'DefineOffers',
  ReviewAutomations = 'ReviewAutomations',
  ReviewBudget = 'ReviewBudget'
} 